import React, { FC } from 'react';
import { MerchantsProvider } from '../store/merchnts/merchants-context';
import { NotificationsProvider } from '../store/notification-context';
import { OrderProvider } from '../store/order/order-context';
import { ApiClientProvider } from '../store/api-client-context';
import { IdentityProvider } from '../store/identyti/identity-context';
import { ActivityProvider } from '../store/activity/activity-context';
import { EligibilityProvider } from '../store/eligibility/eligibility-context';
import { DisputesProvider } from '../store/disputes/disputes-context';
import { ContactsProvider } from '../store/contacts/contacts-context';
import { TablesProvider } from '../store/tables/tables-context';
import { MasterLayout } from '../layout/MasterLayout';
import { PaymentsProvider } from '../store/payments/payments-context';

export const RoutingLayout: FC<{ children: JSX.Element }> = ({ children }) => {
  return (
    <>
      <MerchantsProvider>
        <NotificationsProvider>
          <OrderProvider>
            <PaymentsProvider>
              <ApiClientProvider>
                <IdentityProvider>
                  <ActivityProvider>
                    <EligibilityProvider>
                      <DisputesProvider>
                        <ContactsProvider>
                          <TablesProvider>
                            <MasterLayout>
                              {children}
                            </MasterLayout>
                          </TablesProvider>
                        </ContactsProvider>
                      </DisputesProvider>
                    </EligibilityProvider>
                  </ActivityProvider>
                </IdentityProvider>
              </ApiClientProvider>
            </PaymentsProvider>
          </OrderProvider>
        </NotificationsProvider>
      </MerchantsProvider>
    </>
  );
};
